/** Mensagens da área do fornecedor (guia) — login e cadastro aguardando aprovação do admin. */

export const FORNECEDOR_MSG_AGUARDANDO_APROVACAO =
  'Seu cadastro está em análise. Aguarde a aprovação do administrador para acessar o sistema.';

export const FORNECEDOR_MSG_CADASTRO_RECUSADO =
  'Seu cadastro como parceiro não foi aprovado. Você não tem acesso ao aplicativo. Em caso de dúvida, entre em contato com o suporte.';

/** Exibida ao parceiro quando o admin marca o cadastro como inativo (texto padrão se o admin não personalizar). */
export const FORNECEDOR_MSG_CADASTRO_INATIVO_PADRAO =
  'Cadastro desativado. Entre em contato para maiores detalhes.';
